import { useEffect } from 'react';
import { initPerformanceMonitoring, destroyPerformanceMonitoring } from '@/lib/performanceMonitoring';

export function usePerformanceMonitoring() {
  useEffect(() => {
    const monitor = initPerformanceMonitoring();

    return () => {
      destroyPerformanceMonitoring();
    };
  }, []);
}
